import { useReducer, createContext, Dispatch, PropsWithChildren } from 'react';
import initialState, { InitialStateType } from './initialState';
import { authReducer } from './reducers/auth';
import { AuthActions, EventActions, UIActions, OrgActions } from './actions';
import { orgReducer } from './reducers/org';
import { uiReducer } from './reducers/ui';
import { eventReducer } from './reducers/event';

const AppContext = createContext<{
  state: InitialStateType,
  dispatch: Dispatch<any>
}>({
  state: initialState,
  dispatch: () => null
});

const mainReducer = (state: InitialStateType, action: AuthActions | OrgActions | UIActions | EventActions): InitialStateType => ({
  accountInfo: authReducer(state.accountInfo, action as AuthActions),
  orgInfo: orgReducer(state.orgInfo, action as OrgActions),
  uiInfo: uiReducer(state.uiInfo, action as UIActions),
  eventInfo: eventReducer(state.eventInfo, action as EventActions),
});

export const RandomContext = createContext({ user: null });

const AppProvider = (props: PropsWithChildren)=>{
  const [state, dispatch] = useReducer(mainReducer, initialState);
    return (<AppContext.Provider value={{ state, dispatch }}>
      {props.children}
    </AppContext.Provider>)
  }

export { AppContext, AppProvider };